export { default } from "./ReviewsSkeleton.jsx";
